<template>
    <div>
        <b-card class="mb-5">
            <b-card-body>
                <h4 class="mb-5">Generate Purchase Order (P.O.) Invoice</h4>


                <div v-if="registration.school" class="mt-2 mb-5">
                    <b-button variant="outline-success" @click="useDistrict()"><i class="fas fa-address-card mr-2"></i>Use District Address</b-button>
                    <b-button variant="outline-success" @click="useSchool()" class="ml-3"><i class="fas fa-address-card mr-2"></i>Use School Address</b-button>
                </div>

                <h6>Bill To: </h6>
                <b-form-row>
                    <b-col>
                        <b-form-input placeholder="Organization Name" v-model="registration.poMailTo"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-2">
                    <b-col>
                        <b-form-input placeholder="Attention To" v-model="registration.poAttnTo"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-4">
                    <b-col>
                        <b-form-input placeholder="Phone Number" v-model="registration.poPhone"></b-form-input>
                    </b-col>
                    <b-col>
                        <b-form-input placeholder="Fax Number" v-model="registration.poFax"></b-form-input>
                    </b-col>
                    <b-col cols="6">
                        <b-form-input type="email" placeholder="Email Address" v-model="registration.poEmail"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-4">
                    <b-col cols="9">
                        <b-form-input placeholder="Address" v-model="registration.poAddress1"></b-form-input>
                    </b-col>
                    <b-col>
                        <b-form-input placeholder="Suite, etc." v-model="registration.poAddress2"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-2">
                    <b-col cols="4">
                        <b-form-input placeholder="City" v-model="registration.poCity"></b-form-input>
                    </b-col>
                    <b-col cols="4">

                        <b-form-select placeholder="State" v-model="registration.poState">
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </b-form-select>

                    </b-col>
                    <b-col cols="4">
                        <b-form-input placeholder="Zip" v-model="registration.poZip"></b-form-input>
                    </b-col>
                </b-form-row>

                <b-form-row class="mt-4">
                    <b-col>
                        <b-form-input placeholder="Purchase Order (P.O.) Number" v-model="registration.poNumber"></b-form-input>
                    </b-col>
                </b-form-row>


                <div class="mt-5">
                    <b-button variant="success" @click="generatePO"><i class="fas fa-file-pdf mr-3"></i>Generate Invoice</b-button>
                </div>
            </b-card-body>
        </b-card>

        <b-card>
            <b-card-body>
                <h4 class="mb-4">Activate Registration</h4>

                <div v-if="registration.poPending === 'true'">
                    <p>This registration is <strong class="text-danger">pending</strong> and therefore not completed.  The registrant opted to have the registration payed by purchase
                        order (P.O.).  Once the purchase order process has been fulfilled you can safely activate the registration.  They will receive an e-mail notification that their
                        registration is confirmed once activated.</p>
                    <div class="mt-5">
                        <b-button variant="danger" @click="activate" :disabled="processing"><i class="fas fa-check mr-3"></i>Activate Registration</b-button>
                    </div>
                </div>

                <div v-else>
                    <p>This registration is <strong class="text-success">active</strong> and therefore completed.</p>
                </div>
            </b-card-body>
        </b-card>
    </div>

</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "PO",
        props: ['id', 'code'],
        data: function () {
            return {
                registration: {
                    conference: {},
                    fee: {}
                },
                districts: [],
                schools: [],
                processing: false
            }
        },
        methods: {
            ...mapActions(['getConferenceByCode', 'getRegistrationByCode', 'updatePOInfo', 'getDistricts', 'activateReg']),

            activate() {
                if (confirm('Are sure you are ready to activate and complete this registration?  The purchase order process should be complete before activating.')) {
                    this.processing = true;
                    this.activateReg(this.registration.code).then(result => {
                        this.registration.poPending = 'false';
                        this.processing = false;
                    }, (err) => {
                        window.alert('Something went wrong activating this registration.  Please try again or contact support.');
                        this.processing = false;
                    });
                }
            },

            generatePO() {
                let data = {
                    po_mail_to: this.registration.poMailTo,
                    po_attn_to: this.registration.poAttnTo,
                    po_phone: this.registration.poPhone,
                    po_fax: this.registration.poFax,
                    po_email: this.registration.poEmail,
                    po_address_1: this.registration.poAddress1,
                    po_address_2: this.registration.poAddress2,
                    po_city: this.registration.poCity,
                    po_state: this.registration.poState,
                    po_zip: this.registration.poZip,
                    po_number: this.registration.poNumber
                }
                this.updatePOInfo({code: this.registration.code, data: data}).then(response => {
                    window.open('/#/register/po/' + this.registration.conference.code + '/' + this.registration.code);
                }, err => {
                    console.error(err);
                })
            },

            useSchool() {
                this.registration.poMailTo = this.registration.school.SchoolName;
                this.registration.poAddress1 = this.registration.school.AddressLine1;
                this.registration.poAddress2 = this.registration.school.AddressLine2;
                this.registration.poCity = this.registration.school.City;
                this.registration.poState = 'WA';
                this.registration.poZip = this.registration.school.ZipCode;
            },

            useDistrict() {
                this.registration.poMailTo = this.registration.district.name;
                this.registration.poAddress1 = this.registration.district.address;
                this.registration.poAddress2 = this.registration.district.address_2;
                this.registration.poCity = this.registration.district.city;
                this.registration.poState = 'WA';
                this.registration.poZip = this.registration.district.zip;
            }
        },
        mounted: function () {
            this.getRegistrationByCode(this.code).then(reg => {
                this.registration = reg;
            }, err => {
                console.error(err);
            });
        }
    }
</script>

<style scoped>

</style>